import React, { useState, Fragment } from 'react'
import { FormattedMessage } from 'react-intl';

const languages = [
    {
        code: 'en',
        title: 'English'
    },
    {
        code: 'et',
        title: 'Eesti'
    },
    {
        code: 'ru',
        title: 'Русский'
    },
    {
        code: 'lv',
        title: 'Latviešu'
    },
    {
        code: 'lt',
        title: 'Lietuvių'
    }
]

const Menu = ({ history, locale, switchLanguage }) => {
    const [toggleMenu, setToggleMenu] = useState(false);
    const handleClick = (code) => {
        switchLanguage(code);
        setToggleMenu(false);
        history.push('/');
    }
    const startOver = () => {
        setToggleMenu(false);
        history.push('/');
    }
    const isFrontPage = (history.location.pathname !== '/quiz' && history.location.pathName !== '/final');
    return (
        <Fragment>
            <button onClick={() => setToggleMenu(!toggleMenu)} type="button"  className={`menu__toggle ${toggleMenu ? 'menu__toggle--active' : ''}`}>
                <span />
                <span />
                <span />
            </button>
            <div className={`menu ${toggleMenu ? 'menu--active' : ''}`}>
                <span className="languages__icon" />
                <ul className="languages">
                    {
                        languages.sort(item => (item.code === locale)).map(lang => {
                            if (locale === lang.code) {
                                return <li className="current">{lang.title}</li>
                            }
                            return <li onClick={() => handleClick(lang.code)}>{lang.title}</li>
                        })
                    }
                </ul>
                {
                    !isFrontPage &&
                    <FormattedMessage id="menu.button.again" default="Start the Quiz Over">
                        {
                            label => (
                                <button onClick={startOver} className="btn btn--teal"><span className="label">{label}</span></button>
                            )
                        }
                    </FormattedMessage>
                }
            </div>
        </Fragment>
    )
}

Menu.propTypes = {

}

export default Menu
